import { render, staticRenderFns } from "./ManualUploadTab.vue?vue&type=template&id=9b3e1872&scoped=true&"
import script from "./ManualUploadTab.vue?vue&type=script&lang=ts&"
export * from "./ManualUploadTab.vue?vue&type=script&lang=ts&"
import style0 from "./ManualUploadTab.vue?vue&type=style&index=0&id=9b3e1872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3e1872",
  null
  
)

export default component.exports